export const enrollmentFields = {
    id: 'id',
    firstName: 'firstName',
    lastName: 'lastName',
    sex: 'sex',
    schoolYear: 'schoolYear',
    parentName: 'parentName',
    phoneNumber: 'phoneNumber',
    address: 'address',
    status: 'status',
} as const;
